import { isMobile, isMobileSafari, isIOS } from 'react-device-detect';

export default initData => {
    const {
        debug,
        discoverEnabled,
        environment,
        enableTimeMetrics,
        enableFastClick,
        featureSwitches,
        isHybridAppContext,
        isNativeAppContext,
        splitTests,
        splitTestGroups,
        version,
        environmentHash
    } = initData;

    // Always turn off SPA for native app web views
    if (isHybridAppContext) {
        featureSwitches['spa'] = false;
    }

    return {
        debug,
        discoverEnabled,
        environment,
        enableTimeMetrics,
        enableFastClick,
        featureSwitches,
        environmentHash,
        isHybridAppContext,
        isIOS,
        isNativeAppContext,
        isMobileDevice: isMobile,
        isMobileSafari,
        isSpaNavigationEnabled: true,
        splitTests,
        splitTestGroups,
        version
    };
};
